"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonFieldsCms = void 0;
var CommonFieldsCms = /** @class */ (function () {
    function CommonFieldsCms() {
        this.requiredFieldInputBox = 'Required field';
        this.invalidCharInputBox = 'Invalid character';
        this.iconAccessibilityAriaLabel = 'Icon';
        this.errorAccessibilityAriaLabel = 'Error';
        this.availableAccessibilityAriaLabel = 'Available';
        this.inProgressPanelLabel = 'This is in progress';
    }
    return CommonFieldsCms;
}());
exports.CommonFieldsCms = CommonFieldsCms;
//# sourceMappingURL=CommonFields.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/cms/CommonFields.cms.js
// module id = 2276
// module chunks = 8